<div *ngIf="showHeaderAndSidenav">
  <app-header (sidenavToggle)="toggleSidenav()"></app-header>
  <app-sidenav [isOpen]="sidenavOpen"></app-sidenav>
  <div class="content" [style.margin-left]="sidenavOpen ? '250px' : '0'" style="margin-top: 56px; padding: 20px; transition: margin-left 0.3s;">
    <router-outlet></router-outlet>
  </div>
</div>

<div *ngIf="!showHeaderAndSidenav" class="full-page">
  <router-outlet></router-outlet>
</div>
